import { Link } from "react-router-dom";

const items = [
  { text: "If not you, then WHO." },
  { text: "A referral is not a result. WHO turns the handoff into a completed connection.", link: "/solution" },
  { text: "~200,000 service members transition to civilian life each year (DoD TAP)", link: "/problem" },
  { text: "17.9M living U.S. veterans (VA, 2024) — one accountable connection at a time", link: "/problem" },
  { text: "WHO Guides™ coordinate the workflow. People confirm the outcome.", link: "/impact" },
  { text: "Pittsburgh pilot open now — apply to join the WHO Partner Network", link: "/partners" },
  { text: "Request a demo · become a pilot partner", link: "/contact" },
];

// Duplicate the sequence so the CSS marquee loops seamlessly.
const sequence = [...items, ...items];

export default function MarqueeBanner() {
  return (
    <div
      className="relative w-full max-w-full overflow-hidden bg-navy-deep text-cream border-b border-white/10 group"
      data-testid="marquee-banner"
      role="region"
      aria-label="Announcements"
    >
      <div className="marquee-track flex whitespace-nowrap py-2.5 group-hover:[animation-play-state:paused]">
        {sequence.map((it, i) => (
          <MarqueeItem key={i} {...it} />
        ))}
      </div>
      {/* Edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-navy-deep to-transparent" aria-hidden />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-navy-deep to-transparent" aria-hidden />
    </div>
  );
}

function MarqueeItem({ text, link }) {
  const content = (
    <span className="flex items-center gap-3">
      <span className="text-gold text-xs" aria-hidden>◆</span>
      <span className="text-sm font-medium tracking-wide">{text}</span>
    </span>
  );
  return (
    <span className="flex items-center px-6 shrink-0">
      {link ? (
        <Link to={link} className="hover:text-gold-light transition-colors" data-testid={`marquee-item-${link.replace("/", "")}`}>
          {content}
        </Link>
      ) : (
        content
      )}
    </span>
  );
}
